export default __webpack_public_path__ + "static/media/lp-logo.22d1d21d.png";